// The header on every game and result screen (CLAUDE.md: The game header must
// fit one line).
//
// The game and its number, centred, and nothing else: the way home is the brand
// in the site header and How to play is the "?" beside the archive. No date: a puzzle is identified to the player by its number alone,
// the daily included. The date a daily is published on is still a stored field —
// it is what decides which puzzle today is — but it is never shown.
//
// **On a phone held sideways, on a play screen, it moves into the site header's
// bar**, centred on the page, so the row costs the game no height at all: every
// pixel it gave back goes to the posters and the faces. It is the same component
// in a different place, rendered into the bar's slot, and it comes back as the
// phone is turned upright. **A result screen keeps it under the bar**, as on a
// desktop: that screen scrolls anyway, and has the height to spare.
import { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useSideways } from '../lib/sideways.ts';
import './GameHeader.css';

interface Props {
  game?: string;            // "Running Order"; none on a page that is not a game's
  number?: number;          // none on a notice page, which names the game only
  /** A play screen: sideways, the row goes into the site header's bar. */
  inBar?: boolean;
}

export function GameHeader({ game, number, inBar = false }: Props) {
  const sideways = useSideways();
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  // Before the first paint, so a sideways page never shows a frame without it.
  useLayoutEffect(() => { setSlot(document.getElementById('site-header-slot')); }, []);

  const header = (
    <div className="game-header">
      <h1 className="game-header-title">{game ? (number ? `${game} #${number}` : game) : ''}</h1>
    </div>
  );
  if (!sideways || !inBar) return header;
  return slot ? createPortal(header, slot) : null;
}
